/* eslint-disable prettier/prettier */
import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components/macro';

import { Label, Text } from '@olist/united';

export const StyledForm = styled.form`
  max-width: 410px;
  width: 100%;
`;

export const TextLink = styled(Text.Link).attrs({
  weight: 'bold',
  target: '_blank',
})`
  &:not(:hover) {
    &:visited {
      color: ${({ color }) => themeGet(`colors.${color}`)};
    }
  }

  &:hover,
  &:not(:hover) {
    ${({ textDecoration }) =>
    textDecoration &&
    css`
        text-decoration: ${textDecoration} !important;
      `}
  }
`;

export const CustomLabel = styled(Label)`
  margin-bottom: 4px;
  ${({ danger }) =>
    danger &&
    css`
      color: ${themeGet('colors.foundation.errorDefault')};
    `}
`;
